import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_arrow_left.svg'
import _imports_1 from '@/app/ui/assets/svg/wallet-cod-withdrawal.svg'


const _hoisted_1 = { class: "relative bg-gray-lp-1200 flex flex-col text-12px xxl:text-14px overflow-hidden h-full w-full" }
const _hoisted_2 = { class: "bg-white flex items-center gap-x-3 border-b border-gray-lp-400 px-6 py-3 flex-shrink-0" }
const _hoisted_3 = { class: "text-xl font-semibold" }
const _hoisted_4 = { class: "p-4 lg:p-6 w-full flex flex-col lg:flex-row gap-6 flex-grow min-h-0 overflow-auto" }
const _hoisted_5 = { class: "flex flex-col gap-y-4 w-full" }
const _hoisted_6 = { class: "rounded-2xl py-3 px-4 border border-red-lp-2400 bg-white" }
const _hoisted_7 = { class: "flex items-center gap-3" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "h-5 w-5"
}, null, -1)
const _hoisted_9 = { class: "flex flex-col gap-0.5" }
const _hoisted_10 = { class: "text-sm font-medium" }
const _hoisted_11 = { class: "font-bold text-2xl" }
const _hoisted_12 = { class: "p-4 rounded-xl bg-white" }
const _hoisted_13 = { class: "flex flex-col gap-3" }
const _hoisted_14 = { class: "text-base font-bold" }
const _hoisted_15 = /*#__PURE__*/_createVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_16 = { class: "flex flex-col gap-1" }
const _hoisted_17 = { class: "text-base font-bold" }
const _hoisted_18 = { class: "w-full lg:w-88 lg:flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WithdrawalAmountInput = _resolveComponent("WithdrawalAmountInput")!
  const _component_MaskedPasswordInput = _resolveComponent("MaskedPasswordInput")!
  const _component_SidebarSubmitWithdraw = _resolveComponent("SidebarSubmitWithdraw")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: _imports_0,
        class: "w-6 mr-1 cursor-pointer",
        alt: "back",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }),
      _createVNode("h5", _hoisted_3, _toDisplayString(_ctx.$t("codIncome.withdrawal.titlePage")), 1)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode("div", _hoisted_9, [
              _createVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("codIncome.withdrawal.codBalance")), 1),
              _createVNode("h4", _hoisted_11, _toDisplayString(_ctx.formatPrice(_ctx.balance)), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("codIncome.withdrawal.amountTitle")), 1),
            _createVNode(_component_WithdrawalAmountInput, {
              modelValue: _ctx.withdrawalAmount,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.withdrawalAmount = $event)),
              balance: _ctx.balance,
              "min-amount": _ctx.minAmount,
              "max-amount": _ctx.maxAmount,
              disabled: _ctx.isInputDisabled,
              "onUpdate:isError": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isAmountError = $event))
            }, null, 8, ["modelValue", "balance", "min-amount", "max-amount", "disabled"])
          ]),
          _hoisted_15,
          _createVNode("div", _hoisted_16, [
            _createVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("codIncome.withdrawal.passwordTitle")), 1),
            _createVNode(_component_MaskedPasswordInput, {
              modelValue: _ctx.password,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.password = $event)),
              placeholder: _ctx.$t('codIncome.withdrawal.passwordPlaceholder'),
              "is-error": _ctx.isWrongPassword,
              onChange: _ctx.onPasswordChange
            }, null, 8, ["modelValue", "placeholder", "is-error", "onChange"]),
            _withDirectives(_createVNode("div", { class: "text-red-lp-2400 text-12px xxl:text-14px" }, _toDisplayString(_ctx.$t("codIncome.withdrawal.errorPassword")), 513), [
              [_vShow, _ctx.isWrongPassword]
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_18, [
        _createVNode(_component_SidebarSubmitWithdraw, {
          amount: _ctx.withdrawalAmount,
          password: _ctx.password,
          "is-password-valid": _ctx.isPasswordValidate,
          "balance-type": "cod",
          "on-close": _ctx.goBack,
          "is-amount-error": _ctx.isAmountError
        }, null, 8, ["amount", "password", "is-password-valid", "on-close", "is-amount-error"])
      ])
    ])
  ]))
}